import { FC } from "react"

export const HtmlIcon: FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <svg width="33" height="35" viewBox="0 0 33 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="33" height="35" rx="4" fill="#F7F7F7" />
      <path d="M25 10.218L23.4513 27.5679L16.4896 29.4978L9.54713 27.5705L8 10.218H25Z" fill="#979797" />
      <path
        d="M13.4894 15.8931H16.5001V13.7649H11.1636L11.2145 14.3358L11.7376 20.2006H16.5001V18.0724H13.684L13.4894 15.8931ZM13.9691 21.2648H11.8327L12.1308 24.6064L16.4903 25.8166L16.5001 25.8139V23.5997L16.4908 23.6021L14.1206 22.9621L13.9691 21.2648Z"
        fill="white"
      />
      <path
        d="M9.58203 5.5022H10.6636V6.57074H11.6529V5.5022H12.7345V8.738H11.653V7.65447H10.6636V8.738H9.5821V5.5022H9.58203ZM14.1567 6.57527H13.2047V5.5022H16.191V6.57527H15.2385V8.738H14.1569V6.57527H14.1569H14.1567ZM16.665 5.5022H17.7927L18.4864 6.63917L19.1794 5.5022H20.3076V8.738H19.2305V7.13416L18.4864 8.28466H18.4677L17.7232 7.13416V8.738H16.665V5.5022ZM20.8458 5.5022H21.9277V7.66846H23.4486V8.738H20.8458V5.5022H20.8458Z"
        fill="#979797"
      />
      <path
        d="M16.4932 20.2006H19.1139L18.8668 22.9608L16.4932 23.6014V25.8156L20.8561 24.6064L20.8881 24.2468L21.3883 18.6439L21.4402 18.0724H16.4932V20.2006ZM16.4932 15.8879V15.8931H21.6339L21.6765 15.4148L21.7736 14.3358L21.8244 13.7649H16.4932V15.888V15.8879Z"
        fill="white"
      />
    </svg>
  )
}

